import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ToolService } from "../../../../core/services/tool.service";
import { PartNumber } from "../../../../shared/models/partNumber.model";
import { Log } from "ng2-logger";

@Component({
    selector: 'app-tool-part-numbers-form',
    templateUrl: './tool-part-numbers-form.component.html',
    styleUrls: ['./tool-part-numbers-form.component.scss']
})
export class ToolPartNumbersFormComponent implements OnInit, OnChanges {
    _logger = Log.create(ToolPartNumbersFormComponent.name);

    @Input() selectedPartNumbers: PartNumber[] = [];
    @Input() availableParts: PartNumber[] = [];
    @Input() showValidations = false;

    form: UntypedFormGroup;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['availableParts'] && this.form && this.selectedPartNumbers) {
            this.loadFormValues(this.selectedPartNumbers);
        }
    }

    ngOnInit() {
        this.initForm();
    }

    submit() {
        this._logger.info('submit::')
    }

    initForm() {
        this.form = new UntypedFormGroup({
            partNumbers: new UntypedFormControl([]),
        });
    }

    loadFormValues(selectedPartNumbers: PartNumber[]) {
        this.form.setValue({
            partNumbers: selectedPartNumbers
        })
    }


    resetForm() {
        this._logger.info("resetForm:: with", this.availableParts);
        this.showValidations = false;
        this.form.reset();
    }

    getFormValue() {
        return this.form.value;
    }

    get isFormValid() {
        this.showValidations = true;
        return this.form.valid;
    }
}
